import React from 'react';
import { SelectInput, useRecordContext, useTranslate } from 'react-admin';

const CategoryInput = ({ classes, source, ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	const choices = [
		{ id: 'commemoration', name: translate('Commemoration') },
		{ id: 'conference', name: translate('Conference') },
		{ id: 'festival', name: translate('Festival') },
		{ id: 'guided_tour', name: translate('Guided tour') },
		{ id: 'exhibition', name: translate('Exhibition') },
		{ id: 'music_theater', name: translate('Music-Theater') },
		{ id: 'other', name: translate('Other') },
	];

	return (
		<SelectInput source={source} choices={choices} record={record} {...props} />
	);
};

CategoryInput.defaultProps = {
	source: 'category'
};

export default CategoryInput;
